import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '../../../../../common/components/button/button.component';
import { MatIconButton } from '@angular/material/button';
import { PasswordService } from '../../../../../services/password/password.service';
import { passwordValidator } from '../../../../../validators/passwordValidator';
import { PasswordHint } from '../../../../../common/components/password-hint/password-hint';
import { SuggestionDialogTestIds } from './suggestion-dialog-test-ids';

export interface SuggestionDialogData {
  title: string;
  message: string;
  confirmText: string;
  cancelText?: string;
  svgIcon?: string;
}

@Component({
  selector: 'app-suggestion-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatIcon,
    ButtonComponent,
    MatInput,
    FormsModule,
    MatFormField,
    MatSuffix,
    MatIconButton,
    ReactiveFormsModule,
    PasswordHint
  ],
  templateUrl: './suggestion-dialog.html',
  styleUrl: './suggestion-dialog.scss'
})

/**
 * Begründung: Hierbei handelt es sich um eine Allgemeione Dialogkomponente für Hinweise, welche an der jeweiligen
 * Stelle verändert und eingebaut werden kann.
 */
export class SuggestionDialog {
  dialogRef: MatDialogRef<SuggestionDialog> = inject(MatDialogRef);
  data: SuggestionDialogData = inject(MAT_DIALOG_DATA);
  testIds = SuggestionDialogTestIds;
  isPasswordVisible = false;
  private readonly passwordService = inject(PasswordService);
  private readonly formBuilder = inject(FormBuilder);
  protected resetForm = this.formBuilder.group({
    password: ['', [passwordValidator(), Validators.required]]
  });

  onConfirm(): void {
    this.dialogRef.close(this.resetForm.controls.password.value);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  generatePassword(): void {
    this.resetForm.controls['password'].setValue(this.passwordService.generatePassword());
  }
}
